const SpacerBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#ffd400" d="M0 2h24v20H0z" />
    <path fill="#333" d="M0 0v2h11v8h2V2h11V0H0zM0 24v-2h11v-8h2v8h11v2H0z" />
  </svg>
);

export default SpacerBlockIcon;
